var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let CheckBox = class CheckBox extends LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.checked = false;
        this.variant = 'primary';
    }
    handleChange(e) {
        const target = e.target;
        this.checked = target.checked;
        this.dispatchEvent(new CustomEvent('checkbox-change', {
            detail: this.checked,
            bubbles: true,
            composed: true
        }));
    }
    render() {
        const variantClass = `checkbox--${this.variant}`;
        return html `
      <label class="checkbox-container">
        <input
          class="checkbox ${variantClass}"
          type="checkbox"
          .checked=${this.checked}
          @change=${this.handleChange}
        />
        <span class="label">${this.label}</span>
      </label>
    `;
    }
};
CheckBox.styles = css `
    .checkbox-container {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .checkbox {
      appearance: none;
      width: 20px;
      height: 20px;
      border: 2px solid #ddd; /* Bordure grise par défaut */
      border-radius: 4px;
      display: inline-block;
      position: relative;
      margin-right: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      background-color: white; /* Fond blanc par défaut */
    }

    .checkbox:checked {
      background-color: #4caf50; /* Couleur de fond pour l'état checked */
    }

    .checkbox:checked::after {
      content: '';
      position: absolute;
      top: 1px; /* Ajustement pour centrer verticalement */
      left: 4px; /* Ajustement pour centrer horizontalement */
      width: 6px;
      height: 10px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    .label {
      font-size: 0.875rem;
      color: #333;
    }

    /* Variants */
    .checkbox--primary:checked {
      background-color: #0078d4;
    }
    .checkbox--secondary:checked {
      background-color: #6c757d;
    }
    .checkbox--success:checked {
      background-color: #28a745;
    }
    .checkbox--danger:checked {
      background-color: #dc3545;
    }
    .checkbox--warning:checked {
      background-color: #ffc107;
    }
  `;
__decorate([
    property({ type: String })
], CheckBox.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], CheckBox.prototype, "checked", void 0);
__decorate([
    property({ type: String })
], CheckBox.prototype, "variant", void 0);
CheckBox = __decorate([
    customElement('simple-checkbox')
], CheckBox);
export { CheckBox };
//# sourceMappingURL=CheckBox.js.map